<template>
	<ui-card icon="fal fa-ballot-check" :title="form.menu_name || 'Preencher Proposta'">
		<template #body>
			<ui-load-success
				v-if="loader.overlay"
				:loading="loader.overlayLoading"
				:success="loader.overlaySucess"
			/>

			<div class="area-card">
				<transition name="small-fade">
					<div v-show="loader.body" class="loading-card">
						<ui-load-indicator bgColor="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
					</div>
				</transition>

				<div class="internal-header">
					<h2 class="title">Configurações de Etapa e Status</h2>
					<span class="desc"
						>Informe a Etapa e Status das etapas de
						{{ form.menu_name || 'Preencher Proposta' }}</span
					>
				</div>

				<div class="grid-50 pt-2">
					<ui-select-2
						v-model="form.funnel_start.stage_id"
						:data="funnelStagesOptions"
						:loading="false"
						:disabled="false"
						:show-footer="false"
						:search="false"
						label="Ao criar o cliente será movimentado para a etapa:"
						item-label="name"
						return-value="id"
						@input="handlerStatusStart"
					/>

					<ui-select-2
						v-model="form.funnel_start.status_id"
						:data="funnelStatusStart"
						:loading="false"
						:disabled="disableStatusStart"
						:show-footer="false"
						:search="false"
						label="Ao criar o cliente será movimentado para o status:"
						item-label="name"
						return-value="id"
					/>

					<ui-select-2
						v-model="form.funnel_end.stage_id"
						:data="funnelStagesOptions"
						:loading="false"
						:disabled="false"
						:show-footer="false"
						:search="false"
						label="Ao finalizar o guia será movimentado para a etapa:"
						item-label="name"
						return-value="id"
						@input="handlerStatusEnd"
					/>

					<ui-select-2
						v-model="form.funnel_end.status_id"
						:data="funnelStatusEnd"
						:loading="false"
						:disabled="disableStatusEnd"
						:show-footer="false"
						:search="false"
						label="Ao finalizar o guia será movimentado para o status:"
						item-label="name"
						return-value="id"
					/>
				</div>

				<div class="internal-header line-t">
					<h2 class="title">Reserva Automática</h2>
					<span class="desc">Configurações relacionadas a reserva automática.</span>
				</div>

				<ui-util-box-text-slot
					title="Ao finalizar uma proposta solicitar reserva automática"
					design="mb"
				>
					<ui-switch design="xs" v-model="form.active" :checked="form.active" />
				</ui-util-box-text-slot>

				<ui-input
					v-model="form.time"
					placeholder="__:__"
					label="Tempo para expiração de reserva após a submissão da proposta."
					mask="##:##"
					groupicon="fal fa-clock"
					invertgroup
				/>
			</div>
		</template>
		<template #fl></template>
		<template #fr>
			<ui-button design="md success" :disabled="!canSubmit" @click="submit">Salvar</ui-button>
		</template>
	</ui-card>
</template>
<script>
	import { uiCard } from '@/components/ui/cards'
	import { uiButton } from '@/components/ui/buttons'
	import { uiSwitch, uiInput, uiSelect2 } from '@/components/ui/form'
	import { uiUtilBoxTextSlot } from '@/components/ui/form/util'
	import { uiLoadIndicator } from '@/components/ui'
	import { uiLoadSuccess } from '@/components/ui/overlays'

	import { utilMixin, formMixin, alertMixin } from '@/mixins'
	import { getConfig, saveConfig, getStages } from '../../util/methods'

	const defaultForm = () => ({
		funnel_start: {
			stage_id: null,
			status_id: null,
		},
		funnel_end: {
			stage_id: null,
			status_id: null,
		},
		menu_name: null,
		active: null,
		time: null,
	})

	const defaultDisabled = () => ({})
	const defaultChecked = () => ({})

	const defaultLoader = () => ({
		body: false,
		overlay: false,
		overlayLoading: true,
		overlaySucess: true,
	})

	export default {
		name: 'configuration-digital-folder',

		components: {
			uiCard,
			uiButton,
			uiSelect2,
			uiInput,
			uiSwitch,
			uiLoadSuccess,
			uiUtilBoxTextSlot,
			uiLoadIndicator,
		},

		mixins: [utilMixin, formMixin, alertMixin],

		data() {
			return {
				form: { ...defaultForm() },
				disabled: { ...defaultDisabled() },
				checked: { ...defaultChecked() },
				loader: { ...defaultLoader() },
				proposalSettings: [],
				funnelStagesOptions: [],
				funnelStatusStart: [],
				funnelStatusEnd: [],
				oldForm: {},
			}
		},

		async created() {
			this.loader.body = true

			const [proposalSettings, funnelStagesOptions] = await Promise.all([
				this.getConfig('proposalSettings', 'value_long'),
				this.getStages(),
			])

			this.proposalSettings = proposalSettings
			this.funnelStagesOptions = funnelStagesOptions

			const proposal = this.proposalSettings.proposal
			const reserve = this.proposalSettings.reserve

			this.form.menu_name = proposal.menu_name

			this.form.funnel_start = {
				stage_id: parseInt(proposal.funnel_start.stage_id) || null,
				status_id: parseInt(proposal.funnel_start.status_id) || null,
			}

			this.form.funnel_end = {
				stage_id: parseInt(proposal.funnel_end.stage_id) || null,
				status_id: parseInt(proposal.funnel_end.status_id) || null,
			}

			this.handlerStatusStart(this.form.funnel_start.stage_id, false)
			this.handlerStatusEnd(this.form.funnel_end.stage_id, false)

			this.form.active = this.$mx_checkIsYes(reserve.active)
			this.form.time = reserve.time

			this.loader.body = false
			this.$mx_copyOldForm()
		},

		computed: {
			canSubmit() {
				return this.$mx_isFormChanged && !this.loader.body && this.canSubmitFunnel()
			},

			disableStatusStart() {
				return this.isStatusDisable(this.funnelStatusStart)
			},

			disableStatusEnd() {
				return this.isStatusDisable(this.funnelStatusEnd)
			},

			validateProposalSettings() {
				return {
					...this.proposalSettings,
					reserve: {
						...this.proposalSettings.reserve,
						active: this.$mx_yesOrNo(this.form.active),
						time: this.form.time,
					},
					proposal: {
						...this.proposalSettings.proposal,
						funnel_start: { ...this.funnelValidate(this.form.funnel_start) },
						funnel_end: { ...this.funnelValidate(this.form.funnel_end) },
					},
				}
			},
		},

		methods: {
			getConfig,
			saveConfig,
			getStages,

			handlerStatusStart(id, reset = true) {
				if (reset) this.form.funnel_start.status_id = null
				this.funnelStatusStart = this.getStatusByCustomerId(id)
			},

			handlerStatusEnd(id, reset = true) {
				if (reset) this.form.funnel_end.status_id = null
				this.funnelStatusEnd = this.getStatusByCustomerId(id)
			},

			getStatusByCustomerId(id) {
				if (id && this.funnelStagesOptions.length) {
					const stage = Object.values(this.funnelStagesOptions).find(
						(option) => option.id === parseInt(id),
					)
					return [...stage.status]
				}
				return []
			},

			funnelValidate(funnel) {
				return {
					stage_id: !!funnel.stage_id ? funnel.stage_id.toString() : null,
					status_id: !!funnel.status_id ? funnel.status_id.toString() : null,
				}
			},

			canSubmitFunnel() {
				return (
					((this.funnelStatusStart.length > 0 &&
						this.$mx_hasValue(this.form.funnel_start.status_id)) ||
						(this.funnelStatusStart.length == 0 &&
							!this.$mx_hasValue(this.form.funnel_start.status_id))) &&
					((this.funnelStatusEnd.length > 0 &&
						this.$mx_hasValue(this.form.funnel_end.status_id)) ||
						(this.funnelStatusEnd.length == 0 &&
							!this.$mx_hasValue(this.form.funnel_end.status_id))) &&
					this.$mx_hasValue(this.form.funnel_start.stage_id) &&
					this.$mx_hasValue(this.form.funnel_end.stage_id)
				)
			},

			isStatusDisable(array) {
				return array.length == 0
			},

			async submit() {
				try {
					this.loader.overlay = true
					this.loader.overlayLoading = true

					await this.saveConfig(
						'proposalSettings',
						this.validateProposalSettings,
						'value_long',
					)

					setTimeout(() => {
						this.loader.overlayLoading = false
						this.loader.overlaySucess = true
						setTimeout(() => {
							this.loader.overlay = false
						}, 500)
					}, 500)

					this.$mx_copyOldForm()
					//...
				} catch (error) {
					this.$mx_alertThisOnError(error)
					this.loader.overlaySucess = false
					setTimeout(() => {
						this.loader.overlay = false
					}, 1000)
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
